import Api from './api';

const inspectionsListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/inspections', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createInspectionRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/inspections/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteInspectionRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/inspections/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { inspectionsListRequest, createInspectionRequest, deleteInspectionRequest }



// WEBPACK FOOTER //
// ./src/api/apiInspections.js